import { render } from "./solicitudrevision.vue?vue&type=template&id=42c1902d"
import script from "./solicitudrevision.vue?vue&type=script&lang=js"
export * from "./solicitudrevision.vue?vue&type=script&lang=js"

import "./solicitudrevision.vue?vue&type=style&index=0&id=42c1902d&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__